import React from 'react'
import SearchBar from '../../components/SearchBar'
import { Grid, Row, Table } from 'react-bootstrap'
import { connect } from 'react-redux'
import Breadcrumbs from '../../components/Breadcrumbs'
import qs from 'qs'

import { searchUsers } from '../../actions/user-actions'

import { SEARCH_INSTRUCTIONS, NO_SEARCH_RESULTS } from '../messages'

class Users extends React.Component {
  constructor() {
    super()
    this.state = { query: undefined }
  }

  fullName(user) {
    var fullName = null
    if (user.firstName == null && user.lastName == null) {
      fullName = user.userId
    } else if (user.firstName == null) {
      fullName = user.lastName
    } else if (user.lastName == null) {
      fullName = user.firstName
    } else {
      fullName = `${user.firstName} ${user.lastName}`
    }
    return fullName
  }

  componentDidMount() {
    if (this.props.location.search) {
      let params = qs.parse(this.props.location.search.substring(1))
      this.setState({ query: params.query })
      this.props.searchUsers(params.query)
    }
  }

  search(query) {
    this.props.searchUsers(query)
  }

  render() {
    const { results } = this.props

    return (
      <Grid>
        <Breadcrumbs />
        <SearchBar
          placeholder="Zoek gebruiker"
          value={this.state.query || this.props.query}
          callback={(query) => this.search(query)}
        />
        <Row>
          <div className="tablescontainer">
            {results.length ? (
              <Table striped>
                <thead>
                  <tr>
                    <th>Email</th>
                    <th>Naam</th>
                    <th>IdP</th>
                    <th>Actieve licenties</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((result, index) => (
                    <tr key={index} onClick={() => this.props.history.push(`/gebruikers/${result.user.id}`)}>
                      <td style={{overflowWrap: "anywhere"}}>{result.user.email}</td>
                      <td style={{overflowWrap: "anywhere"}}>{this.fullName(result.user)}</td>
                      <td>{result.user.identityProvider?.name}</td>
                      <td>{result.licenseCount}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <SearchInfo />
            )}
          </div>
        </Row>
      </Grid>
    )
  }
}

let SearchInfo = () => (
  <div>
    <p>{SEARCH_INSTRUCTIONS}</p>
    <p>Zoek op:</p>
    <ul>
      <li>User ID</li>
      <li>Email</li>
      <li>Voornaam</li>
      <li>Achternaam</li>
      <li>Groepsnaam</li>
      <li>Klantnaam</li>
      <li>
        Product
        <ul>
          <li>Naam</li>
          <li>EAN</li>
        </ul>
      </li>
    </ul>
    <p>{NO_SEARCH_RESULTS}</p>
  </div>
)

export default connect((state) => state.users.userSearch, { searchUsers })(Users)
